const validateHppWeeklyHours = (hours?: number) => {
  // Násobek 0.25 v rozsahu 0.25 - 40
  if (hours === undefined || (hours % 0.25 === 0 && hours > 0 && hours <= 40)) return undefined;
  return 'Hodnota musí být násobkem 0.25 větším než 0, maximálně 40.';
};
export default validateHppWeeklyHours;
